import _ from "lodash";

const sortRulesCommon = [
  {key: "data.title", order: "asc"},
  {key: "data.vendorCode", order: "asc"},
  {key: "data.sizeTitle", order: "asc"},
  {key: "data.color", order: "asc"},
  {key: "data.barcode", order: "asc"},
]

///Нужно всегда проверять, какие правила используются

export const sortProducts = (list, rules) => {
    if (!rules) {
      rules = sortRulesCommon
    }
    return list.sort((a, b) => {
      for (const rule of rules) {
        const { key, order = 'asc' } = rule;
        const valA = _.get(a, key);
        const valB = _.get(b, key);

        let compare = 0;
        if (typeof valA === 'string' && typeof valB === 'string') {
          compare = valA.localeCompare(valB);
        } else {
          if (Array.isArray(valA) && Array.isArray(valB)) {
            valA.join("").localeCompare(valB.join(""))
          }
          else {
            compare = valA - valB;
          }
        }

        if (compare !== 0) {
          return order === 'asc' ? compare : -compare;
        }
      }
      return 0;
    });
}